
const changeActiveItem = (elem: HTMLElement, className:string) => {
    [].forEach.call(elem.parentNode &&
        elem.parentNode.children, (el: HTMLElement) => el.classList.remove(className));
    elem.classList.add('active');
};

export default changeActiveItem;